import React from 'react';
import Dashboard from './Dashboard';
import './Home.css';

const LoggedInHome = () => {
  return <Dashboard />;
};

export default LoggedInHome;

